<template>
  <div id="echartsmap" style="width: 100%; height: 100%">ditu</div>
</template>
<script>
import * as echarts from "echarts";
import china from "./china.json";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var echartsmap = document.getElementById("echartsmap");
    var myChart = echarts.init(echartsmap);
    var option = {
      tooltip: {
        trigger: "item",
        formatter: function (params) {
          return params.name + "<br/>Value: " + params.value;
        },
      },
      geo: {
        type: "map",
        map: "china",
        layoutCenter: ["50%", "70%"], // 距离左右，上下距离的百分比
        layoutSize: "90%", // map百分比大小
        zoom: 1.5,
        roam: true,
        label: {
          // 鼠标移入字体颜色
          emphasis: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },
        itemStyle: {
          // 默认区块样式
          normal: {
            borderColor: "#00dde2", // 边框颜色
            borderWidth: 1,
            areaColor: {
              // 省份色
              colorStops: [
                {
                  offset: 0,
                  color: "#024a76",
                },
              ],
            },
          },
          // 鼠标移入颜色
          emphasis: {
            areaColor: "#012b52",
            borderWidth: 1,
            borderColor: "#fff",
          },
        },
      },
      series: [
        {
          type: "lines",
          zlevel: 2,
          effect: {
            show: true,
            period: 3,
            trailLength: 0.5,
            color: "#ffde00",
            symbolSize: 10,
            symbol: "arrow",
          },
          lineStyle: {
            normal: {
              color: "#ffde00",
              width: 1,
              opacity: 1,
              curveness: 0.1,
            },
          },
          data: [
            {
              fromName: "馆陶",
              toName: "河南", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311], // 安吉的经纬度坐标
                [113.624997, 34.747196], // 上海的经纬度坐标
              ],
            },
            {
              fromName: "馆陶",
              toName: "青海", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311],
                [101.779996, 36.620995],
              ],
            },
            {
              fromName: "馆陶",
              toName: "成都", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311],
                [104.066284, 30.572939],
              ],
            },
            {
              fromName: "馆陶",
              toName: "北京", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311],
                [116.407004, 39.904595],
              ],
            },
            {
              fromName: "馆陶",
              toName: "甘肃", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311], // 安吉的经纬度坐标
                [103.825997, 36.059398], // 上海的经纬度坐标
              ],
            },
            {
              fromName: "馆陶",
              toName: "云南", // 例如: 上海、北京、广州等
              coords: [
                [115.2818, 36.548311], // 安吉的经纬度坐标
                [102.710004, 25.045294], // 上海的经纬度坐标
              ],
            },
          ],
        },
        {
          type: "effectScatter",
          coordinateSystem: "geo",
          zlevel: 2,
          rippleEffect: {
            brushType: "stroke",
          },
          label: {
            normal: {
              show: true,
              position: "right",
              formatter: "{b}", // 标签内容，这里显示城市名
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
          symbolSize: function (val) {
            return val[2] / 10; // 根据销量设置点大小
          },
          itemStyle: {
            normal: {
              color: "#ddb926", // 圆点颜色
            },
          },
          data: [
            { name: "河南", value: 4500 },
            { name: "北京", value: 6500 },
            { name: "青海", value: 6900 },
            { name: "甘肃", value: 4000 },
            { name: "云南", value: 3500 },
            { name: "成都", value: 7500 },
          ],
        },
      ],
    };
    echarts.registerMap("china", china);
    myChart.setOption(option);

    // 监听窗口大小变化
    window.addEventListener("resize", () => {
      myChart.resize();
    });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
